import httpcommonFile from "../../baseUrl/httpcommonFile";

const sentFilesToRecipients = (id) => {
  debugger;
  return httpcommonFile.get(`/api/files/files?userId=${id}&type=sent`);
};

const getAllFiles = (id) => {
  debugger;
  return httpcommonFile.get(`/api/files/files?userId=${id}&type=all`);
};
const getRecentFiles = (data) => {
  return httpcommonFile.get(`/api/files/files?userId=${data.id}&type=${data.type}`);
};

const SentFileService = {
  sentFilesToRecipients,
  getAllFiles,
  getRecentFiles
};

export default SentFileService;
